/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for ObjectDetection controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { ObjectDetectionImageRequest, RequestOptions, ObjectDetectionBounds, EnqueueImageOperationResponse, DrawDetectedObjectsBoundsImageRequest } from "../models";

@Injectable({ providedIn: "root" })
export class ObjectDetectionService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    detectObjects(objectDetectionImageRequest: ObjectDetectionImageRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<Array<ObjectDetectionBounds>>;
    detectObjects(objectDetectionImageRequest: ObjectDetectionImageRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<Array<ObjectDetectionBounds>>>;
    detectObjects(objectDetectionImageRequest: ObjectDetectionImageRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<Array<ObjectDetectionBounds>>>;
    detectObjects(objectDetectionImageRequest: ObjectDetectionImageRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/detect-objects`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: objectDetectionImageRequest,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    objectDetectionAsync(objectDetectionImageRequest: ObjectDetectionImageRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<EnqueueImageOperationResponse>;
    objectDetectionAsync(objectDetectionImageRequest: ObjectDetectionImageRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EnqueueImageOperationResponse>>;
    objectDetectionAsync(objectDetectionImageRequest: ObjectDetectionImageRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EnqueueImageOperationResponse>>;
    objectDetectionAsync(objectDetectionImageRequest: ObjectDetectionImageRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/detect-objects/async`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: objectDetectionImageRequest,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    drawDetectedObjectsBounds(drawDetectedObjectsBoundsImageRequest: DrawDetectedObjectsBoundsImageRequest, observe?: 'body', options?: RequestOptions<'blob'>): Observable<Blob>;
    drawDetectedObjectsBounds(drawDetectedObjectsBoundsImageRequest: DrawDetectedObjectsBoundsImageRequest, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<Blob>>;
    drawDetectedObjectsBounds(drawDetectedObjectsBoundsImageRequest: DrawDetectedObjectsBoundsImageRequest, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<Blob>>;
    drawDetectedObjectsBounds(drawDetectedObjectsBoundsImageRequest: DrawDetectedObjectsBoundsImageRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/detect-objects/draw-bounds`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: drawDetectedObjectsBoundsImageRequest,
            observe,
            headers,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    drawDetectedObjectsAsync(drawDetectedObjectsBoundsImageRequest: DrawDetectedObjectsBoundsImageRequest, observe?: 'body', options?: RequestOptions<'json'>): Observable<EnqueueImageOperationResponse>;
    drawDetectedObjectsAsync(drawDetectedObjectsBoundsImageRequest: DrawDetectedObjectsBoundsImageRequest, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<EnqueueImageOperationResponse>>;
    drawDetectedObjectsAsync(drawDetectedObjectsBoundsImageRequest: DrawDetectedObjectsBoundsImageRequest, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<EnqueueImageOperationResponse>>;
    drawDetectedObjectsAsync(drawDetectedObjectsBoundsImageRequest: DrawDetectedObjectsBoundsImageRequest, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/detect-objects/draw-bounds/async`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: drawDetectedObjectsBoundsImageRequest,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
